import React, { useState } from 'react';
import { Alert, Input } from 'antd';
import { getAccessToken } from '../../../services/authService';
import { toast } from 'react-toastify';
import ExtraWindow from './ExtraWindow';
import { addExtraToScene, readExtraDetails, assignExtraScenes } from './extraDetails-helper';

export default function AddExtrasCharacter({ sceneIndex, setUpdateData, setIsOpen, body, scriptData, editor, records = [], onSaved }) {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const live = editor?.getBody() || body;
  const close = () => setIsOpen(false);
  const save = async () => {
    if (saving) return;
    setError('');
    if (!name.trim()) { setError('Enter an Extra name.'); return; }
    setSaving(true);
    try {
      const copy = new DOMParser().parseFromString(editor ? editor.getContent() : live.innerHTML, 'text/html');
      const sourceScene = [...live.querySelectorAll('.sceneHeadings')][sceneIndex];
      if (!sourceScene) throw new Error('Select a scene before adding an Extra.');
      const key = addExtraToScene(copy.body, name, sceneIndex, records);
      const saved = readExtraDetails(copy.body, key, records);
      const token = getAccessToken();
      if (!token) throw new Error('Please sign in again before saving.');
      const response = await fetch(`${process.env.REACT_APP_DEV_API}/document/${scriptData?._id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ content: copy.body.innerHTML }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || 'Could not add Extras. Please try again.');
      // Reuse the exact saved identity/scene UID, never generate a second key on success.
      const apply = () => {
        if (!live.contains(sourceScene)) throw new Error('The selected scene changed. Reopen the script to see the saved Extra.');
        sourceScene.setAttribute('data-scene-uid', saved.originSceneUid);
        assignExtraScenes(live, key, [saved.originSceneUid], saved);
      };
      if (editor) { editor.undoManager.transact(apply); editor.fire('Change'); } else apply();
      setUpdateData?.(prev => !prev); onSaved?.(); toast.success('Extras added'); close();
    } catch (e) { setError(e.message || 'Could not add Extras. Please try again.'); }
    finally { setSaving(false); }
  };
  return <ExtraWindow title="Add Extras" saving={saving} onCancel={close} onSave={save} saveLabel="Add">
    {error && <Alert type="error" message={error} className="mb-4" />}
    <label className="flex flex-col gap-2 text-sm">Character Name<Input aria-label="Character Name" placeholder="Enter extra character" maxLength={200} disabled={saving} value={name} onChange={e => setName(e.target.value.toUpperCase())} /></label>
  </ExtraWindow>;
}